import styled from 'styled-components';

const FlexColumn = styled.div`
 flex-direction: column;
`;

export default FlexColumn;
